export const getLanguage = () => {
  return 'en';
};